import { formatPrice } from '../../../../utils/format-price'
import type { Item } from '../models'

export const getPriceInfo = (data: Item['price'], pageLocale: string) => {
  if (data?.value) {
    return {
      ...(data?.priceDiscount?.value && data?.priceDiscount?.value < data?.value
        ? {
            currentPriceTextProps: {
              content: formatPrice(
                Number(data?.priceDiscount?.value),
                data?.priceCurrency,
                pageLocale
              )
            },
            originalPriceTextProps: {
              content: formatPrice(
                Number(data?.value),
                data?.priceCurrency,
                pageLocale
              )
            },
            ...(data?.priceDiscount?.discountValueDescription && {
              message: data?.priceDiscount?.discountValueDescription
            })
          }
        : {
            currentPriceTextProps: {
              content: formatPrice(
                Number(data?.value),
                data?.priceCurrency,
                pageLocale
              )
            }
          })
    }
  }
  return undefined
}
